import styled from 'styled-components';

export const ContainerCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  justify-content: center;
  width: 100%;
  padding: 16px;
  font-family: 'Radio Canada', sans-serif;
`;
